<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Edit'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link
            :to="{
              name: 'edit-service-invoices',
              params: { id: $route.params.invoiceId }
            }"
          >
            {{ serviceInvoiceName }}
          </router-link>
          <i class="mr-2"></i>
          <small class="">{{ $t("LABELS.EDIT") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <DeleteButton
            v-on:onDelete="onDelete()"
            v-permission="['service-delete']"
          ></DeleteButton>
          <SaveButtonDropdown
            :defaultAction="'continue'"
            :isLoading="isLoadingServiceInvoiceRow"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
      <template v-slot:body>
        <ServiceInvoiceRowsForm
          v-if="!loading"
          ref="ServiceInvoiceRowsForm"
          :form="form"
        ></ServiceInvoiceRowsForm>

        <v-overlay :value="!firstLoader && isLoadingServiceInvoiceRow">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="example-tools justify-content-center">
          <BackButton></BackButton>
          <DeleteButton
            v-on:onDelete="onDelete()"
            v-permission="['service-delete']"
          ></DeleteButton>
          <SaveButtonDropdown
            :defaultAction="'continue'"
            :isLoading="isLoadingServiceInvoiceRow"
            v-on:save="onSave($event)"
          ></SaveButtonDropdown>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { FETCH_SERVICE_INVOICE } from "@/modules/service-invoices/store/service-invoices.module";
import {
  FETCH_SERVICE_INVOICE_ROW,
  UPDATE_SERVICE_INVOICE_ROW,
  DELETE_SERVICE_INVOICE_ROW
} from "@/modules/service-invoice-rows/store/service-invoice-rows.module";

import SaveButtonDropdown from "@/view/content/forms/components/SaveButtonDropdown.vue";
import KTCard from "@/view/content/Card.vue";
import ServiceInvoiceRowsForm from "../components/ServiceInvoiceRowsForm.vue";
import { mapGetters } from "vuex";

export default {
  name: "ServiceInvoiceRowsEdit",
  components: {
    KTCard,
    SaveButtonDropdown,
    ServiceInvoiceRowsForm
  },
  data() {
    return {
      loading: true,
      errors: {},
      form: {
        serviceInvoiceId: null,
        name: null,
        code: null,
        price: null,
        totalPrice: 0,
        totalQty: 0,
        serviceExpenses: []
      },
      serviceInvoice: {}
    };
  },
  computed: {
    ...mapGetters(["isLoadingServiceInvoiceRow"]),
    serviceInvoiceName() {
      return (
        this.serviceInvoice.invoiceNumber +
        " " +
        this.serviceInvoice.serviceVendor
      );
    }
  },
  mounted() {
    this.fetchServiceInvoice();
    this.getServiceInvoiceRow();
  },
  methods: {
    fetchServiceInvoice() {
      this.$store
        .dispatch(FETCH_SERVICE_INVOICE, this.$route.params.invoiceId)
        .then(data => {
          this.serviceInvoice = data.data;

          this.$store.dispatch(SET_BREADCRUMB, [
            {
              title: this.$i18n.t("MENU.ITEM.SERVICE.INVOICES"),
              route: { name: "list-service-invoices" }
            },
            {
              title: this.serviceInvoiceName,
              route: {
                name: "edit-service-invoices",
                params: { id: this.$route.params.invoiceId }
              }
            },
            { title: this.$i18n.t("LABELS.EDIT") }
          ]);
        });
    },
    getServiceInvoiceRow() {
      let id = this.$route.params.id;
      this.id = id;
      this.$store
        .dispatch(FETCH_SERVICE_INVOICE_ROW, id)
        .then(data => {
          this.form = data.data;
          this.loading = false;
        })
        .catch(response => {
          if (response.status === 404) {
            this.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "list-service-invoices" });
          }
        });
    },
    onSave(next) {
      let vm = this;
      this.$refs.ServiceInvoiceRowsForm.$v.form.$touch();
      if (this.$refs.ServiceInvoiceRowsForm.$v.form.$anyError) {
        vm.$notify({
          group: "notify",
          type: "error",
          title: "<i class='flaticon-close'></i> Warning",
          text: "Please fill all required fields correctly"
        });
        return;
      }

      this.$store
        .dispatch(UPDATE_SERVICE_INVOICE_ROW, {
          id: this.id,
          payload: this.form
        })
        .then(data => {
          vm.errors = data.data.errors;
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });

          if (next == "continue") {
            //
          }
          if (next == "new") {
            //New
            this.$router.push({ name: "add-service-invoice-rows" });
          }
          if (next == "exit") {
            this.$router.push({
              name: "edit-service-invoices",
              params: { id: this.form.serviceInvoiceId }
            });
          }
        })
        .catch(response => {
          this.errors = this.$errors.format(response.data.errors || {});
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    },
    onDelete() {
      this.$dialog.confirm(this.$t("BUTTON.PLEASE_CONFIRM")).then(() => {
        this.$store
          .dispatch(DELETE_SERVICE_INVOICE_ROW, this.$route.params.id)
          .then(data => {
            this.$notify({
              group: "notify",
              type: "success",
              title: "<i class='flaticon2-checkmark'></i> Success",
              text: data.message
            });
            this.$router.push({
              name: "edit-service-invoices",
              params: { id: this.form.serviceInvoiceId }
            });
          })
          .catch(response => {
            this.$notify({
              group: "notify",
              type: "error",
              title: this.$t("ALERTS.ERROR"),
              text: response.data.message
            });
          });
      });
    }
  }
};
</script>
